import { useAnimations, Environment, useGLTF } from '@react-three/drei'
import { Physics, RigidBody } from '@react-three/rapier'
import { Perf } from 'r3f-perf'
import { useRef, useState, useEffect } from 'react'
import Fishes from './fishes.jsx'
import * as THREE from 'three'
import { TextureLoader } from 'three'
import { useThree, useFrame, useLoader } from '@react-three/fiber'
import Player from './Player.jsx'
import { Water } from './Water.js'
import { Ground } from './Ground.js'
import tunnelVertexShader from './shaders/tunnelVert.glsl'
import tunnelFragmentShader from './shaders/tunnelFrag.glsl'

export default function Experience()
{

    const path = './aquarium.draco.glb'
    const aquarium = useGLTF(path)
    // console.log(aquarium, 'aquarium')

    useEffect(() => {
        if (!aquarium) return
        // const cude = aquarium.meshes.Cube
        // cude.material.transparent = true;
        // cude.material.opacity = 0.2;
        // cude.material.depthWrite = false; // 防止深度冲突
        // cude.material.alphaTest = 0.2; // 消除边缘锯齿
        // // 解决透明度排序问题
        // cude.material.side = THREE.DoubleSide;

        const cylinderMaterial = new THREE.ShaderMaterial({
              vertexShader: tunnelVertexShader,
              fragmentShader: tunnelFragmentShader,
              transparent: true,
              blending: THREE.NormalBlending,
              depthTest: true,
              depthWrite: true,
              side: THREE.DoubleSide,
            });
        

        const cylinder = aquarium.meshes.Cylinder
        cylinder.material = cylinderMaterial;
        cylinder.renderOrder = 1;

        // cylinder.material.transparent = true;
        // cylinder.material.opacity = 0.3;
        // cylinder.material.depthWrite = false;
        // cylinder.material.alphaTest = 0.3;
        // cylinder.material.side = THREE.DoubleSide;


        sceneRef.current.children.forEach(child => {
            // console.log(child, 'child');
            if (child.isMesh && (child.name.indexOf('sand') >= 0 || child.name === 'Cylinder')) {
                child.material.flatShading = false;
            }
        });

    }, []);

    const sceneRef = useRef();

    const { scene } = useThree();
    const [envMap, setEnvMap] = useState();
    let water = useRef();
    let ground = useRef();
    const poolTexture = useLoader(TextureLoader, './ground_sand.jpg')
    poolTexture.wrapS = THREE.RepeatWrapping;
    poolTexture.wrapT = THREE.RepeatWrapping;
    
    

    useFrame(({ clock }) => {
        if (!sceneRef) return;
        

        if (scene.environment && poolTexture && !envMap) {
            setEnvMap(scene.environment)
            water.current = new Water({
                environmentMap: scene.environment,
            });
            scene.add(water.current);

            ground.current = new Ground({
                texture: poolTexture
            });
            
            scene.add(ground.current);

            document.getElementsByClassName('loading')[0].style.display = 'none';
            // const cylinder = aquarium.meshes.Cylinder
            // cylinder.material = water.current.material
            // cylinder.material.flatShading = false;
            // cylinder.renderOrder = 1;
            
        }
        
        // 随时间变化形态键影响值
        const time = clock.getElapsedTime();
        const waveIntensity = Math.sin(time);
        sceneRef.current.children.forEach(child => {
            if (child.morphTargetInfluences?.length > 0) {
                child.morphTargetInfluences[0] = waveIntensity
            }
        });

        water.current?.update(time)
        ground.current?.update(time)
        
    });

    useGLTF.preload(path);

    return <>

        {/* <Perf position="top-left" /> */}

        {/* <OrbitControls /> */}

        <Environment background files="./qwantani_moonrise_puresky_2k.exr" />

        {/* <primitive castShadow ref={sceneRef} object={ aquarium.scene } />
        <Fishes /> */}
        
        <Physics debug={ false }>
            <directionalLight castShadow position={ [ 1, 2, 3 ] } intensity={ 4.5 } shadow-normalBias={ 0.05 } />
            <ambientLight intensity={ 1.5 } />

            <RigidBody
                type="fixed"
                colliders="trimesh"
                position={[0, 0, 0]}
                restitution={0.2}
                friction={0}
                >
                <primitive castShadow ref={sceneRef} object={ aquarium.scene } />
            </RigidBody>
            
            <Fishes />
            <Player />
        </Physics>

    </>
}